/* eslint-disable @typescript-eslint/no-explicit-any */
import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { IImprint, imprint } from '@thehubz/shared/utils';

@Component({
  selector: 'thehubz-content',
  templateUrl: './content.component.html',
  styleUrls: ['./content.component.scss'],
})
export class ContentComponent implements OnInit {
  current: string | undefined;
  imprint: IImprint = imprint;
  hasBackButton = true;

  constructor(
    private route: ActivatedRoute,
    private location: Location,
  ) {
    const params = new URLSearchParams(document.location.search);

    if (params.get('referrer') === 'sharing') {
      this.hasBackButton = false;
    }
  }

  ngOnInit() {
    this.route.params.subscribe((routeParams) => {
      this.current = routeParams['param'];
    });
  }

  /**
   * Return to the previous route visited.
   */
  goBack() {
    this.location.back();
  }
}
